import React from 'react'
import { TextField } from "@mui/material"
import PropTypes from 'prop-types'

const formatDateMask = (value) => {
    // garante string
    if (!value) return ""
    // remove tudo que não é dígito
    let digits = String(value).replace(/\D/g, "")
    // limita a 8 caracteres (DDMMYYYY)
    digits = digits.substring(0, 8)
    // monta a máscara
    if (digits.length <= 2) {
        return digits
    }
    if (digits.length <= 4) {
        return digits.substring(0, 2) + '/' + digits.substring(2)
    }
    return (
        digits.substring(0, 2) +
        '/' +
        digits.substring(2, 4) +
        '/' +
        digits.substring(4)
    )
}

const TextFieldFormatDate = (props) => {
    const changeValue = (event) => {
        const masked = formatDateMask(event.target.value)
        if (props.onChange) props.onChange(masked)
    }

    return (
        <TextField
            fullWidth
            multiline={props.multiline || false}
            InputLabelProps={props.focused ? { shrink: true } : undefined}
            InputProps={{ readOnly: props.readOnly ? props.readOnly : false }}
            variant={props.variant || "standard"}
            label={props.label}
            rows={props.rows || 1}
            value={props.value || ""}
            type="text"
            onChange={changeValue}
            error={props.error}
            helperText={props.helperText}
            FormHelperTextProps={props.FormHelperTextProps}
            inputRef={props.inputRef}
        />
    )
}

TextFieldFormatDate.propTypes = {
    label: PropTypes.string,
    variant: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    focused: PropTypes.bool,
    rows: PropTypes.number,
    multiline: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    FormHelperTextProps: PropTypes.object,
    inputRef: PropTypes.object,
}

export default TextFieldFormatDate